/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment } from "react";

import Theme from "./theme";

import smallField from "assets/img/small-field.PNG";
import largeField from "assets/img/large-field.PNG";

const renderInfoModal = (modalActive, showModal) => {
  return (
    <div className={`modal${modalActive ? " is-active" : ""}`}>
      <div onClick={() => showModal(false)} className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Job Ad Form Field Types</p>
          <button
            onClick={() => showModal(false)}
            className="delete"
            aria-label="close"
          ></button>
        </header>
        <section className="modal-card-body">
          <h1 className="title is-5">Small Field</h1>
          <p className="content">
            Small fields are small input text boxes you can use for short
            information.
          </p>
          <p>
            This is an example of a <b>small field</b>:
          </p>
          <br />
          <img src={smallField} className="modalImg" />
          <br /> <br />
          <h1 className="title is-5">Large Field</h1>
          <p className="content">
            Large fields are large input text boxes you can use for short
            information.
          </p>
          <p>
            This is an example of a <b>large field</b>:
          </p>
          <br />
          <img src={largeField} className="modalImg" />
        </section>
        <footer className="modal-card-foot">
          <button
            onClick={() => showModal(false)}
            className="button is-success"
          >
            Okay
          </button>
        </footer>
      </div>
    </div>
  );
};

const renderPreviewModal = (modalActive, showModal) => {
  return (
    <div className={`modal${modalActive ? " is-active" : ""}`}>
      <div onClick={() => showModal(false)} className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Job Ad Form Field Types</p>
          <button
            onClick={() => showModal(false)}
            className="delete"
            aria-label="close"
          ></button>
        </header>
        <section className="modal-card-body">
          <h1 className="title is-5">Small Field</h1>
          <p className="content">
            Small fields are small input text boxes you can use for short
            information.
          </p>
          <p>
            This is an example of a <b>small field</b>:
          </p>
          <br />
          <img src={smallField} className="modalImg" />
          <br /> <br />
          <h1 className="title is-5">Large Field</h1>
          <p className="content">
            Large fields are large input text boxes you can use for short
            information.
          </p>
          <p>
            This is an example of a <b>large field</b>:
          </p>
          <br />
          <img src={largeField} className="modalImg" />
        </section>
        <footer className="modal-card-foot">
          <button
            onClick={() => showModal(false)}
            className="button is-success"
          >
            Okay
          </button>
        </footer>
      </div>
    </div>
  );
};

const FormBuilderView = (props) => {
  const {
    fields,
    addField,
    clearFields,
    infoModal,
    previewModal,
    showInfoModal,
    showPreviewModal,
    preview,
    submit,
  } = props;

  return (
    <Theme>
      {renderInfoModal(infoModal, showInfoModal)}
      {renderPreviewModal(previewModal, showPreviewModal)}
      <h5 className="title is-5">Build a Job Ad Form</h5>
      <p className="info">
        <span onClick={() => showInfoModal(true)}>
          ( <i className="fas fa-info-circle icon"></i> Check tutorial )
        </span>
      </p>
      <br />
      <button
        onClick={() => addField("small")}
        className="button is-info submit"
      >
        Add Small Field
      </button>
      &nbsp; &nbsp;
      <button
        onClick={() => addField("large")}
        className="button is-info submit"
      >
        Add Large Field
      </button>
      &nbsp; &nbsp;
      <button onClick={clearFields} className="button is-success submit">
        Clear
      </button>
      <br /> <br />
      {fields.map((field) => (
        <Fragment>
          {field.type === "small" ? (
            <div className="field">
              <p className="control">
                <input
                  className="input is-info"
                  type="email"
                  placeholder="Small Field Title"
                />
              </p>
            </div>
          ) : (
            <div className="field">
              <div className="control">
                <input
                  className="input is-info"
                  type="email"
                  placeholder="Large Field Title"
                />
              </div>
            </div>
          )}
        </Fragment>
      ))}
      <br />
      {fields.length !== 0 && (
        <Fragment>
          <button onClick={preview} className="button is-success">
            Preview
          </button>
          &nbsp; &nbsp;
          <button onClick={submit} className="button is-success">
            Save Form
          </button>
        </Fragment>
      )}
    </Theme>
  );
};

export default FormBuilderView;
